const isProductionWebAppUrl = () => window.location.hostname === 'vortic.art';
export default isProductionWebAppUrl;
